module.exports = __webpack_public_path__ + "13_smats.jpg?8e7651e7071be2ed65994145e96b688f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/13_smats.jpg
// module id = 152
// module chunks = 0